import { render, staticRenderFns } from "./btYhubData.vue?vue&type=template&id=2de71774"
import script from "./btYhubData.vue?vue&type=script&lang=js"
export * from "./btYhubData.vue?vue&type=script&lang=js"
import style0 from "./btYhubData.vue?vue&type=style&index=0&id=2de71774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports